'use client';

import { useEffect } from 'react';

import { useAppInsightsEvents } from '../../analytics/appInsights/useAppInsightsEvents';
import { useTranslations } from '../../i18n/TranslationsProvider';
import { ButtonLink } from '../buttonLink';
import { Icon } from '../icon/Icon';

const TakedaError = ({ error }: { error: Error | string }) => {
	const { trackException } = useAppInsightsEvents();
	const { t } = useTranslations();
	const message = typeof error === 'string' ? error : error?.message;

	useEffect(() => {
		trackException(error);
	}, [error, trackException]);

	return (
		<div className="flex justify-center pb-5 pt-8">
			<div role="alert" className="w-[80%] sm:w-[60%] md:w-1/2 lg:w-1/3 mt-3 flex gap-3">
				<div className="flex flex-col gap-2">
					<div>
						<Icon name="error" className="fill-takeda-dark-red-600" />
					</div>
					<h3 className="text-xl font-medium mt-[1.5rem] mb-[0.5rem] uppercase">
						{t.general.errors.sorryMsg}
					</h3>
					<p>{t.general.errors.refreshPage}</p>
					<details className="open:[&_svg]:-rotate-180">
						<summary className="flex cursor-pointer list-none items-center gap-2 text-takeda-dark-red-600 select-none">
							<div>{t.general.common.moreDetails}</div>
							<Icon name="chevron-down" className="transition duration-200 ease-in-out" />
						</summary>
						<div className="border-2 bg-gray-100 rounded-[0px] p-3">
							<code>{message || t.general.errors.unknownError}</code>
						</div>
					</details>
					<div className="flex justify-end">
						<ButtonLink href="/">{t.general.errors.returnToHomepage}</ButtonLink>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TakedaError;
